import type { SessionStoreState } from './session.type'

export const sessionInitialState: SessionStoreState = {
  token: null,
  isLoading: false,
  error: null,
  lastFetched: null,
}
